/* eslint-disable */
import React from 'react';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import deleteIcon from 'Images/delete_icon.svg';
import SectionCard from './SectionCard';
import { StyledField, StyledSelect } from './helpers';

const TRANSPORT_TYPES = [
  { value: 'GARE', label: 'En gare' },
  { value: 'DOMICILE', label: 'À domicile' },
];

const DeliverySection = ({
  data, expeditions = [], onChangeTransport, onAddTransport, onDeleteTransport,
}) => (
  <SectionCard id="livraison" title="Livraison">
    <Typography sx={{ fontSize: '13px', color: '#8398AE', mb: '20px', mt: '-8px' }}>
      Condition de livraison :{' '}
      <Box component="span" sx={{ color: '#007BC6', fontWeight: 600, cursor: 'pointer' }}>
        {data.conditionLivraison}
      </Box>
    </Typography>

    {data.transports.map((t) => (
      <Grid container spacing={2} key={t.id} alignItems="center" sx={{ mb: '12px' }}>
        <Grid item xs>
          <StyledSelect
            label="Transport primaire"
            value={t.expeditionId ? String(t.expeditionId) : ''}
            onChange={(e) => {
              const exp = expeditions.find((ex) => String(ex.id) === e.target.value);
              onChangeTransport(t.id, 'expeditionId', exp ? exp.id : null);
              onChangeTransport(t.id, 'transportPrimaire', exp ? exp.name : '');
            }}
            options={expeditions.map((e) => ({ value: String(e.id), label: e.name }))}
          />
        </Grid>
        <Grid item xs>
          <StyledSelect
            label="Type de transport"
            value={t.typeTransport}
            onChange={(e) => onChangeTransport(t.id, 'typeTransport', e.target.value)}
            options={TRANSPORT_TYPES}
          />
        </Grid>
        <Grid item xs="auto">
          <IconButton
            onClick={() => onDeleteTransport(t.id)}
            sx={{ mt: '2px', '&:hover img': { filter: 'brightness(0) saturate(100%) invert(29%) sepia(89%) saturate(876%) hue-rotate(182deg) brightness(100%) contrast(101%)' } }}
          >
            <img src={deleteIcon} alt="delete" style={{ width: 20, height: 20, objectFit: 'contain' }} />
          </IconButton>
        </Grid>
      </Grid>
    ))}

    <Box
      onClick={onAddTransport}
      sx={{
        mt: '8px',
        border: '1px dashed #D1D5DB',
        borderRadius: '8px',
        py: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
        cursor: 'pointer',
        color: '#8398AE',
        transition: 'all 0.15s',
        '&:hover': { borderColor: '#007BC6', color: '#007BC6' },
      }}
    >
      <AddIcon sx={{ fontSize: 18 }} />
      <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>Ajouter un transport</Typography>
    </Box>
  </SectionCard>
);

export default DeliverySection;
